import React, { useState, useEffect } from 'react';
import TextLoop from "react-text-loop";
import { trackEvent } from "../../services/analytics";
import {Navbar, Nav, Image, NavDropdown} from 'react-bootstrap'
import { useTranslation } from 'react-i18next';
import LandingPageNav from "../../components/navbars/landingPage";
import FooterLandingPage from "../../components/footers/landing";
import Section from "../../components/landingPage/sections";
import {Helmet} from "react-helmet";

const Landing = (props) => {
    const { t, i18n } = useTranslation();
    const [ lang, setLang ] = useState('id');
    const [ loading, setLoading ] = useState(true);

    useEffect(()=> {
        let lng = lang;
        if (props.match.params.lang) {
            lng = props.match.params.lang
        } else if (localStorage.getItem('language')){
            lng = localStorage.getItem('language')
        }
        setLang(lng);
        setLoading(false);
        i18n.changeLanguage(lng)
        localStorage.setItem('language', lng);
    },[]);

    const onClickSignIn = (name) => {
        trackEvent('Click',{
            action: "track",
            category: "Buttons",
            label: name,
            event: "Click"
        })
    };

    const onClickSignUp = (name) => {
        trackEvent('Click',{
            action: "track",
            category: "Buttons",
            label: name,
            event: "Click"
        })
    };



    if (loading) {
        return (
            <section>
                <div>
                    <div className="row no-gutters align-items-md-center text-center text-md-left">
                        <div className="col-lg-1"/>
                        <div className="order-1 ml-auto col-lg-4">
                        </div>
                        <div className="order-2 col-lg-7 mb-4 hover-scale-110">
                            <img alt="Biteship Shipment" src="/images/landing/make_order.png" className="img-fluid"/>
                        </div>
                    </div>
                </div>
            </section>
        )
    }

    return (
      <div style={{backgroundColor:'white'}}>
          <Helmet>
              <meta charSet="utf-8" />
              <title>Biteship: Pesan Berbagai Macam Kurir dalam Satu Platform</title>
              <meta name="description" content="Biteship adalah platform untuk melakukan pemesanan dari berbagai macam kurir dibangun untuk para pemilik bisnis.
              Terdapat lebih dari 20 Kurir Indonesia yang bergabung menjadi partner pengiriman. Kami membantu optimasi pengiriman Anda secara end-to-end." />
              <link rel="canonical" href="https://biteship.com" />
          </Helmet>
          <LandingPageNav/>
          <section className="header-section">
              <br/>
              <div className="row no-gutters align-items-md-center text-center text-md-left pt-4">
                  <div className="col-lg-1"/>
                  <div className="order-1 ml-auto col-lg-4">
                      <div className="card-body pl-5 header-title">
                          <h1 className="text-black lh-150"><strong>{t('landing.headerTitle')}</strong></h1>
                          <h2 className="text-violet-500 lh-150"><strong>{t('landing.header2Title')}</strong></h2>
                          <p className="lead lh-180">
                            {t('landing.subheaderTitle')}
                          </p>
                          <a href="https://dashboard.biteship.com/signin" onClick={() => onClickSignIn('Sign In Main Header')}>
                              <button className="btn btn-primary mt-5" >
                                  {t('landing.headerButton')}
                              </button>
                          </a>
                          <a href="https://s.id/biteship-web-home-sales-section" onClick={() => onClickSignIn('Sign In Main Header')}>
                              <button className="btn btn-secondary mt-5 ml-3 border" >
                                  {t('landing.contactSales')}
                              </button>
                          </a>
                      </div>
                  </div>
                  <div className="order-2 col-lg-7 mb-4 hover-scale-110">
                      <img alt="Biteship Shipment" src="/images/landing/make_order.png" className="img-fluid"/>
                  </div>
              </div>
          </section>

          <section className="client-section slice slice-lg bg-skew-reverse">
              <div className="container">
                  <div className="text-center">
                      <div className="fluid-paragraph mt-3">
                          <h3 className="text font-weight-bold">{t('landing.clientTitle')}</h3>
                      </div>
                      <div className="fluid-paragraph mt-3">
                          <p className="text-muted lead lh-180">{t('landing.clientSubtitle')}</p>
                      </div>
                  </div>
                  <div className="row justify-content-center">
                      <div className="client col-lg-2 col-md-3 col-4 py-3">
                          <Image alt="realityclub" src="/images/clients/logo/rc-dark.png"/>
                      </div>
                      <div className="client col-lg-2 col-md-3 col-4 py-3">
                          <Image alt="tjetak" src="/images/clients/logo/tjetak-dark.png"/>
                      </div>
                      <div className="client col-lg-2 col-md-3 col-4 py-3">
                          <Image alt="qoala" src="/images/clients/logo/qoala-dark.png"/>
                      </div>
                      <div className="client col-lg-2 col-md-3 col-4 py-3">
                          <Image alt="kitabisa" src="/images/clients/logo/kitabisa-dark.png"/>
                      </div>
                      <div className="client col-lg-2 col-md-3 col-4 py-3">
                          <Image alt="asumsi" src="/images/clients/logo/asumsi-dark.png"/>
                      </div>
                      {/*<div className="client col-lg-2 col-md-3 col-4 py-3">*/}
                      {/*    <Image alt="menjadi manusia" src="/images/clients/logo/menjadi-manusia-dark.png"/>*/}
                      {/*</div>*/}
                  </div>
              </div>
          </section>

          <section className="slice slice-lg text-center bg-lighter " id="sct-what-we-do">
              <div className="container">
                  <div className="pt-3 pb-4 mb-4">
                      <h2 className="text font-weight-bold" >{t('landing.featureTitle')}</h2>
                  </div>
                  <div className="row row-grid">
                      <div className="col-lg-4">
                          <div className="">
                              <div className="pb-5">
                                  <div
                                      className="icon bg-swift-pink text-white rounded-circle icon-lg icon-shape shadow">
                                      <i className="fas fa-truck-pickup"></i>
                                  </div>
                              </div>
                              <h5 className="font-weight-bold text-swift-pink">{t('landing.feature1')}</h5>
                              <p className="mt-2 mb-0">
                                {t('landing.featureDesc1')}
                              </p>
                          </div>
                      </div>
                      <div className="col-lg-4">
                          <div className="">
                              <div className="pb-5">
                                  <div
                                      className="icon bg-swift-pink text-white rounded-circle icon-lg icon-shape shadow">
                                      <i className="fas fa-city"></i>
                                  </div>
                              </div>
                              <h5 className="font-weight-bold text-swift-pink">{t('landing.feature2')}</h5>
                              <p className="mt-2 mb-0">{t('landing.featureDesc2')}</p>
                          </div>
                      </div>
                      <div className="col-lg-4">
                          <div className="">
                              <div className="pb-5">
                                  <div
                                      className="icon bg-swift-pink text-white rounded-circle icon-lg icon-shape shadow">
                                      <i className="fas fa-code"></i>
                                  </div>
                              </div>
                              <h5 className="font-weight-bold text-swift-pink">{t('landing.feature3')}</h5>
                              <p className="mt-2 mb-0">{t('landing.featureDesc3')}</p>
                          </div>
                      </div>
                  </div>
              </div>
          </section>

          <section className="slice bg-violet-900">
              <div className='container'>
                <div className="row">
                    <div className="my-4 p-0 col-lg-6 pr-5">
                        <h2 className='text-tiffany-500'>
                            <strong>
                                Pengiriman mudah diatur dengan dashboard
                            </strong>
                        </h2>
                        <p className='text-white lead lh-180'>
                            Biteship membantu Anda memudahkan operasional sehari-hari dengan menyediakan dashboard yang dapat digunakan oleh tim Anda dari berbagai ukuran tim.
                        </p>
                        <p className='text-white lead lh-180'>
                            Dengan dashboard Biteship, Anda dapat melihat seluruh transaksi dan monitor semua pengiriman yang sedang berjalan.
                        </p>
                        <a href="https://dashboard.biteship.com/signin" onClick={() => onClickSignIn('Sign In Main Header')}>
                            <button className="btn btn-primary mt-2" style={{backgroundColor:`#03c1ae`}}>
                                {t('landing.headerButton')}
                            </button>
                        </a>
                    </div>
                    <div className="my-4 p-0 col-lg-6">
                        <img alt="Biteship Shipment" src="/images/landing/dashboard-home.png" className="img-fluid rounded"/>
                    </div>
                </div>
              </div>
          </section>

          <section className="slice">
              <div className='container'>
                <div className="row">
                    <div className="my-4 p-0 col-lg-6 pr-5">
                        <h2 className='text-black mt-6'>
                            <strong>
                                API khusus dibuat untuk developer untuk memudahkan integrasi                            
                            </strong>
                        </h2>
                        <p className='lead lh-180'>
                            Kami sangat memperhatikan bagaimana developers dapat mengintegrasikan layanan Biteship ke webiste.
                        </p>
                    
                        <a href="/docs/api" onClick={() => onClickSignIn('Sign In Main Header')}>
                            <button className="btn btn-primary">
                                API Reference
                            </button>
                        </a>
                    </div>
                    <div className="my-4 p-0 col-lg-6">
                        <img alt="Biteship Shipment" src="/images/landing/biteship-dashboard-api.png" className="img-fluid rounded"/>
                    </div>
                </div>
              </div>
          </section>


          <section className="slice slice-lg">
              <br/>
              <br/>
              <div className="mt-2 text-center">
                  <h3 className="font-weight-bold">{t('landing.logisticPartner')}</h3>
              </div>
              <div className="row d-flex justify-content-center">
                  <h5 className="mr-2">{t('landing.send')}</h5>{" "}
                  <TextLoop>
                      <h5 className="text-swift-pink"><strong>{t('landing.document')}</strong></h5>
                      <h5 className="text-swift-pink"><strong>{t('landing.package')}</strong></h5>
                      <h5 className="text-swift-pink"><strong>{t('landing.food')}</strong></h5>
                  </TextLoop>{" "}
                  <h5 className="mx-2">{t('landing.through')}</h5>{" "}
                  <TextLoop>
                      <h5 className="text-swift-pink"><strong>{t('landing.jne')}</strong></h5>
                      <h5 className="text-swift-pink"><strong>{t('landing.deliveree')}</strong></h5>
                      <h5 className="text-swift-pink"><strong>{t('landing.gojek')}</strong></h5>
                  </TextLoop>
              </div>
              <div className="mt-4 mb-4">
                  <div className="text-center">
                      <p className="lead lh-180">{t('landing.logisticPartnerDesc1')}<br/>{t('landing.logisticPartnerDesc2')}</p>
                  </div>
              </div>
              <div className="container mt-4">
                  <div className="hover-blurable">
                      <a href="#">
                          <div className="blurable-item client-group row justify-content-center">
                              <div className="client col-lg-2 col-md-3 col-4 py-3">
                                  <img alt="Biteship jne" src="images/landing/jne.png"/>
                              </div>
                              <div className="client col-lg-2 col-md-3 col-4 py-3">
                                  <img alt="Biteship wahana" src="images/landing/wahana.png"/>
                              </div>
                              <div className="client col-lg-2 col-md-3 col-4 py-3">
                                  <img alt="Biteship gosend" src="images/landing/gosend.png"/>
                              </div>
                              <div className="client col-lg-2 col-md-3 col-4 py-3">
                                  <img alt="Biteship paxel" src="images/landing/paxel.png"/>
                              </div>
                              <div className="client col-lg-2 col-md-3 col-4 py-3">
                                  <img alt="Biteship sicepat" src="images/landing/sicepat.png"/>
                              </div>
                              <div className="client col-lg-2 col-md-3 col-4 py-3">
                                  <img alt="Biteship jnt" src="images/landing/jnt.png"/>
                              </div>
                              <div className="client col-lg-2 col-md-3 col-4 py-3">
                                  <img alt="Biteship tiki" src="images/landing/tiki.png"/>
                              </div>
                              <div className="client col-lg-2 col-md-3 col-4 py-3">
                                  <img alt="Biteship deliveree" src="images/landing/deliveree.png"/>
                              </div>
                              <div className="client col-lg-2 col-md-3 col-4 py-3">
                                  <img alt="Biteship fedex" src="images/landing/fedex.png"/>
                              </div>
                              <div className="client col-lg-2 col-md-3 col-4 py-3">
                                  <img alt="Biteship anteraja" src="images/landing/anteraja.png"/>
                              </div>
                              <div className="client col-lg-2 col-md-3 col-4 py-3">
                                  <img alt="Biteship grab" src="images/landing/grab.png"/>
                              </div>
                              <div className="client col-lg-2 col-md-3 col-4 py-3">
                                  <img alt="Biteship rpx" src="images/landing/rpx.png"/>
                              </div>
                              <div className="client col-lg-2 col-md-3 col-4 py-3">
                                  <img alt="Biteship jet" src="images/landing/jet.png"/>
                              </div>
                              <div className="client col-lg-2 col-md-3 col-4 py-3">
                                  <img alt="Biteship lion" src="images/landing/lion.png"/>
                              </div>
                              <div className="client col-lg-2 col-md-3 col-4 py-3">
                                  <img alt="Biteship sap" src="images/landing/sap.png"/>
                              </div>
                              <div className="client col-lg-2 col-md-3 col-4 py-3">
                                  <img alt="Biteship qrim" src="images/landing/qrim.png"/>
                              </div>
                              <div className="client col-lg-2 col-md-3 col-4 py-3">
                                  <img alt="Biteship pos" src="images/landing/pos.png"/>
                              </div>
                          </div>
                      </a>
                  </div>
              </div>
              <div style={{height:320}}/>
          </section>

          <Section/>
          <FooterLandingPage/>
      </div>

    );
};

export default Landing;
